module.exports = __webpack_public_path__ + "img/diamond_128px.22e2c7f1.png";